// Shared file-type pill styling (bg/text/border) keyed by file category.
// Uses design-token tints only - no raw Tailwind palette colors.

export const FILE_TYPE_PALETTE = {
  IMAGE: "bg-secondary/10 text-secondary-dark border-secondary/20",
  PDF: "bg-danger/10 text-danger border-danger/20",
  OFFICE: "bg-success/10 text-success border-success/20",
  TEXT: "bg-warning/10 text-warning border-warning/20",
  MARKDOWN: "bg-primary/5 text-primary border-primary/10",
  OTHER: "bg-surface text-mediumgrey border-surface-hover",
};

export const getFileTypePalette = (category) =>
  FILE_TYPE_PALETTE[category] || FILE_TYPE_PALETTE.OTHER;
